//VARS      
var allModal = document.getElementById('wistia-modal'),
    openModalbutton = document.getElementById('open-wistia-video'),
    wistia_video_id = openModalbutton.getAttribute('data-wistia-id'),
    video_tag = document.getElementById("product-intall-video"),
    the_overlay = document.querySelector('.overlay[data-v-ebed439a]'),
    closeModal = document.querySelector('#wistia-modal .modal-wrapper'),
    get_720_url = '';

//GET VIDEO DATA
fetch('https://fast.wistia.com/embed/medias/'+wistia_video_id+'.json')
.then(response => response.json())
.then((data) => {
    get_video_url(data);
})
.catch((error) => {
    console.error('Error:', error);
});
//UPDATE URL
function get_video_url(data) { 
    get_720_url = data.media.assets.find(asset => asset.display_name === '720p').url.replace('.bin', '/installation.mp4');
}
//STOP
function stop_video() {
    video_tag.pause();
    video_tag.currentTime = 0;
} 
//OPEN & PLAY
function open_play_video() {
    allModal.classList.add('fade-enter-active');
    allModal.classList.remove('fade-leave-active');
    the_overlay.classList.add('open');
    video_tag.setAttribute("src", get_720_url); 
    video_tag.load();
    video_tag.play();
}
//CLOSE AND RESET
function close_reset_video() {
    allModal.classList.add('fade-leave-active');
    allModal.classList.remove('fade-enter-active');
    the_overlay.classList.remove('open');
    stop_video();
    video_tag.setAttribute("src", ""); 
}      
//OPEN
openModalbutton.addEventListener('click', function (e) {
    (e).preventDefault();
    open_play_video();
});
//CLOSE
closeModal.addEventListener('click', function (e) {
    (e).preventDefault();
    if (allModal.classList.contains('fade-enter-active')) {
        close_reset_video();
    }
});